import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_BY_ID } from "../Schema/Member";

export const useGetMemberById = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const { refetch } = useQuery(GET_MEMBER_BY_ID, {
    variables: {
      id: id,
    },
    onCompleted: ({ getMemberById }) => {
      // console.log("getMemberById :", getMemberById);
      setData(getMemberById || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { data, loading, refetch };
};
